import { ProgramEvent } from '@cue/api';
import { Image } from '@cue/atoms';
import { PageParams } from '@project/site/layout';
import { AgendaEventTime } from '@project/site/modules/agenda/agenda-event/event-time';
import { navigate } from 'gatsby';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Textfit } from 'react-textfit';
import ReactDomServer from 'react-dom/server';

const ShareEventPageTemplate = (params: PageParams) => {
  const {
    pageContext: { event },
  } = params;

  const url = process.env.GO_API_BASE_URL;
  const shareImage = event ? `${url}share/${event.id}.png` : '';

  useEffect(() => {
    const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
    const path = decodeURIComponent(params.get('path') || '');
    const screenshot = params.get('screenshot');

    if (path && event) {
      window.history.replaceState(
        'object',
        typeof document !== 'undefined' ? document.title : '',
        location.href.split('?')[0],
      );
      navigate(`${path}?uid=${event.id}`);
    } else if (!screenshot) {
      navigate('/');
    }
  }, [event]);

  return (
    <>
      <Helmet>
        <meta property="og:image" content={shareImage} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:title" content={event?.title} />
        <meta property="og:description" content={event?.description} />
        <meta property="twitter:title" content={event?.title} />
        <meta property="twitter:description" content={event?.description} />
        <meta property="twitter:image" content={shareImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Siemens" />
        <meta name="twitter:url" content={url} />
      </Helmet>
      <div className="share-event" id="share-event-wrapper">
        {event && <ShareEventData {...event} />}
      </div>
    </>
  );
};

export const ShareEventData = (event: ProgramEvent) => {
  const { t } = useTranslation();
  console.log('EVENT', event);

  const stage = event?.categories?.[0]?.title || t('agenda.preview.stagetitle');

  return (
    <>
      <div className="share-siemens-logo">
        <Image src="/theme/siemens/logo-white.svg" />
      </div>
      <Textfit className="head-line" mode="single" min={24} max={24}>
        {t('agenda.preview.headline')}
      </Textfit>
      <Textfit className="share-title" mode="multi">
        {event?.title}
      </Textfit>
      <Textfit
        className={`share-subtitle${!event?.start ? ' no-date' : ''}`}
        mode="single"
        min={24}
        max={24}>
        {stage}
        <br />

        {!!event?.start && (
          <>
            {/*   {TimeUtil.getUtc(event?.start).format('DD MMMM')}
            {' | '}
            {TimeUtil.getUtc(event?.start).format('hh.mm a')} */}
            {ReactDomServer.renderToString(
              <AgendaEventTime
                {...{
                  start: event?.start,
                  end: event?.end,
                  showTimeZone: true,
                  eventLanguage: 'en',
                  asString: true,
                }}
              />,
            ).replace(/(<([^>]+)>)/gi, '')}
          </>
        )}
      </Textfit>
      <Textfit className="share-cta" mode="single">
        {t('agenda.preview.cta')}
      </Textfit>

      <Image src="/theme/siemens/sharing/main.webp" />
    </>
  );
};

export default ShareEventPageTemplate;
